import { Navigate, useLocation } from "react-router-dom";
import useAuth from "@/hooks/useAuth";

// Wrap protected pages: bounces to /login?next=<current> if not signed in.
export default function RequireAuth({ children }) {
  const { isSignedIn } = useAuth();
  const loc = useLocation();
  if (!isSignedIn) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
